import React, { useState } from "react";

const StudentsAttendanceHistory = () => {
    const [search, setSearch] = useState("");

    const daysInMonth = 31;

    const students = [
        {
            id: 20251,
            name: "SANDYA RANI",
            session: "STAFF SESSION",
            attendance: [
                "A", "A", "A", "H", "A", "A", "A", "A", "A", "A",
                "H", "A", "A", "A", "A", "A", "A", "H", "A", "A",
                "A", "A", "A", "A", "H", "A", "A", "A", "A", "A", "A"
            ]
        },
        {
            id: 20252,
            name: "CHANDHAN SRIDHAR",
            session: "STAFF SESSION",
            attendance: [
                "P", "P", "P", "H", "P", "P", "P", "P", "P", "P",
                "H", "P", "P", "P", "P", "P", "P", "H", "P", "P",
                "P", "P", "P", "P", "H", "P", "P", "P", "P", "P", "P"
            ]
        },
        {
            id: 20253,
            name: "B.SHRAVYA",
            session: "STAFF SESSION",
            attendance: [
                "L", "P", "P", "H", "P", "A", "P", "P", "P", "P",
                "H", "P", "P", "P", "P", "P", "P", "H", "P", "P",
                "P", "P", "P", "P", "H", "P", "P", "P", "P", "P", "P"
            ]
        }
    ];

    const filteredStudents = students.filter((student) =>
        student.name.toLowerCase().includes(search.toLowerCase())
    );

    const getCounts = (attendance) => {
        return {
            present: attendance.filter((x) => x === "P").length,
            absent: attendance.filter((x) => x === "A").length,
            late: attendance.filter((x) => x === "L").length,
            working: attendance.filter((x) => x !== "H").length,
        };
    };

    return (
        <>
            <div className="card shadow-sm">
                <div className="card-header">
                    <div className="container-fluid">
                        <div className="row g-3">

                            {/* Academic Year */}
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">
                                    Academic Year
                                </label>
                                <select
                                    className="form-select"
                                    name="academicYear"
                                >
                                    <option value="">All</option>
                                    <option>2024-2025</option>
                                    <option>2025-2026</option>
                                    <option>2026-2027</option>
                                </select>
                            </div>

                            {/* Month */}
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">
                                    Month
                                </label>
                                <select
                                    className="form-select"
                                    name="month"
                                >
                                    <option value="">All</option>
                                    <option>January</option>
                                    <option>February</option>
                                    <option>March</option>
                                    <option>April</option>
                                    <option>May</option>
                                    <option>June</option>
                                    <option>July</option>
                                    <option>August</option>
                                    <option>September</option>
                                    <option>October</option>
                                    <option>November</option>
                                    <option>December</option>
                                </select>
                            </div>

                            {/* Curriculum */}
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">
                                    Curriculum
                                </label>
                                <select
                                    className="form-select"
                                    name="curriculum"
                                >
                                    <option value="">All</option>
                                    <option>SSC</option>
                                    <option>CBSE</option>
                                    <option>ICSE</option>
                                </select>
                            </div>

                            {/* Class */}
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">
                                    Class
                                </label>
                                <select
                                    className="form-select"
                                    name="className"
                                >
                                    <option value="">All</option>
                                    <option>PLAY GROUP</option>
                                    <option>NURSERY</option>
                                    <option>PP-1</option>
                                    <option>PP-2</option>
                                    <option>1ST CLASS</option>
                                    <option>2ND CLASS</option>
                                    <option>3RD CLASS</option>
                                    <option>4TH CLASS</option>
                                    <option>5TH CLASS</option>
                                    <option>6TH CLASS</option>
                                    <option>7TH CLASS</option>
                                    <option>8TH CLASS</option>
                                    <option>9TH CLASS</option>
                                    <option>10TH CLASS</option>
                                </select>
                            </div>

                            {/* Section */}
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">
                                    Section
                                </label>
                                <select
                                    className="form-select"
                                    name="section"
                                >
                                    <option value="">All</option>
                                    <option>A</option>
                                    <option>B</option>
                                    <option>C</option>
                                    <option>D</option>
                                    <option>E</option>
                                </select>
                            </div>

                            {/* Attendance Status */}
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">
                                    Attendance Status
                                </label>
                                <select
                                    className="form-select"
                                    name="status"
                                >
                                    <option value="">All</option>
                                    <option value="P">Present</option>
                                    <option value="A">Absent</option>
                                    <option value="L">Late</option>
                                    <option value="H">Holiday</option>
                                </select>
                            </div>

                            {/* Buttons */}
                            <div className="col-12">
                                <div className="d-flex justify-content-end gap-2 mt-2">
                                    <button className="btn btn-primary">
                                        <i className="bi bi-search me-1"></i>
                                        Search
                                    </button>

                                    <button className="btn btn-secondary">
                                        <i className="bi bi-arrow-clockwise me-1"></i>
                                        Reset
                                    </button>

                                    <button className="btn btn-success">
                                        <i className="bi bi-file-earmark-excel me-1"></i>
                                        Export Excel
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="card-body">

                    {/* Top Controls */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex gap-2">
                            <select
                                className="form-select"
                                style={{ width: "80px" }}
                            >
                                <option>10</option>
                                <option>25</option>
                                <option>50</option>
                            </select>

                            <button className="btn btn-secondary">
                                <i className="bi bi-cloud-download-fill"></i>
                            </button>
                        </div>

                        <div className="text-center small fw-semibold">
                            <span className="text-warning me-3">
                                H - Holiday
                            </span>

                            <span className="text-success me-3">
                                P - Present
                            </span>

                            <span className="text-danger">
                                A - Absent
                            </span>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <label>Search:</label>

                            <input
                                type="text"
                                className="form-control"
                                style={{ width: "180px" }}
                                value={search}
                                onChange={(e) =>
                                    setSearch(e.target.value)
                                }
                            />
                        </div>
                    </div>

                    {/* Attendance Table */}

                    <div className="">
                        <div className="tblScrollX" >
                            <table className="table table-bordered table-sm align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th>S.No</th>
                                        <th>RFID</th>
                                        <th>Name</th>
                                        <th>Session</th>

                                        {Array.from(
                                            { length: daysInMonth },
                                            (_, i) => (
                                                <th
                                                    key={i}
                                                    className="text-center"
                                                >
                                                    {i + 1}
                                                </th>
                                            )
                                        )}

                                        <th>Total Working Days</th>
                                        <th>Total Present Days</th>
                                        <th>Total Absent Days</th>
                                        <th>Total Late Days</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredStudents.map(
                                        (student, index) => {
                                            const counts = getCounts(
                                                student.attendance
                                            );

                                            return (
                                                <tr key={student.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{student.id}</td>
                                                    <td>{student.name}</td>
                                                    <td>{student.session}</td>

                                                    {student.attendance.map(
                                                        (status, dayIndex) => (
                                                            <td
                                                                key={dayIndex}
                                                                className="text-center fw-bold"
                                                            >
                                                                {status === "P" && (
                                                                    <span className="text-success">
                                                                        P
                                                                    </span>
                                                                )}

                                                                {status === "A" && (
                                                                    <span className="text-danger">
                                                                        A
                                                                    </span>
                                                                )}

                                                                {status === "L" && (
                                                                    <span className="text-primary">
                                                                        L
                                                                    </span>
                                                                )}

                                                                {status === "H" && (
                                                                    <span className="text-warning">
                                                                        Sun
                                                                    </span>
                                                                )}
                                                            </td>
                                                        )
                                                    )}

                                                    <td>{counts.working}</td>
                                                    <td>{counts.present}</td>
                                                    <td>{counts.absent}</td>
                                                    <td>{counts.late}</td>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* <div className="mt-3">
                            <button className="btn btn-info text-white">
                                Export to Excel
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default StudentsAttendanceHistory;